export function formatDurationTime(totalMinutes) {
  const hours = totalMinutes > 60 ? parseInt(totalMinutes / 60) : 0;
  const minutes = parseInt(
    hours > 0 ? totalMinutes - hours * 60 : totalMinutes
  );
  if (hours > 0 && minutes == 0) {
    return `${hours}h`;
  }
  if (hours === 0) {
    return `${minutes}min`;
  }

  return `${hours}h ${minutes}min`;
}

export function formatDurationTimeSeconds(totalSeconds) {
  if (totalSeconds < 0) {
    return "";
  }
  totalSeconds = Math.round(totalSeconds);
  let minutes = parseInt(totalSeconds / 60);
  const seconds = totalSeconds - minutes * 60;
  const hours = minutes > 60 ? parseInt(minutes / 60) : 0;
  minutes = minutes > 60 ? minutes - hours * 60 : minutes;
  const output = [];

  if (hours > 0) {
    output.push(`${hours}h`);
  }

  if (minutes > 0) {
    output.push(`${minutes}min`);
  }

  if (seconds > 0) {
    output.push(`${seconds}s`);
  }

  return output.join(" ");
}
